import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { fetchPeriodicalKultSubjectGroup } from "../api/periodicalLibraryService";
import { fetchKultSubjectGroups } from "../api/reportsService";
import { KULT_SUBJECT_GROUPS_QUERY_KEY, PERIODICAL_KULT_SUBJECT_GROUP_QUERY_KEY, } from "../types/reports/kultSubjectGroup";
export var usePeriodicalKultSubjectGroup = function (titleId, enabled) {
    if (enabled === void 0) { enabled = true; }
    var kyInstance = useOkapiKy();
    return useQuery([PERIODICAL_KULT_SUBJECT_GROUP_QUERY_KEY, titleId], function () { return fetchPeriodicalKultSubjectGroup(kyInstance, titleId); }, { enabled: enabled && !!titleId });
};
export var useKultSubjectGroupOptions = function (enabled) {
    if (enabled === void 0) { enabled = true; }
    var kyInstance = useOkapiKy();
    return useQuery([KULT_SUBJECT_GROUPS_QUERY_KEY], function () { return fetchKultSubjectGroups(kyInstance); }, { enabled: enabled, staleTime: 60 * 60 * 1000 });
};
